import React from 'react';
import HelpIcon from '@icons/common/help.svg';
import { HelpLink } from './styled';

interface HelpRedirectProps {
  redirectUrl?: string;
  style?: React.CSSProperties;
}

export default function HelpRedirect({ redirectUrl, style = {} }: HelpRedirectProps) {
  return (
    <HelpLink href={redirectUrl} target="_blank" rel="noopener noreferrer" style={style}>
      <HelpIcon />
    </HelpLink>
  );
}
